import sweetAlert from './sweet-alert';

export default sweetAlert;